<template>
    <div class="gmf-modal-overlay">
        <img class="gmf-loot-crate-open-image" :src="openLootCrateUrl" :class="{ 'gmf-open': lootCratePos }" />
    </div>
</template>

<style>
.gmf-loot-crate-open-image {
    width: 448px;
    height: 448px;
    max-width: 448px;
    max-height: 448px;
    aspect-ratio: 1;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 60%);
    bottom: 50%;
    transition: opacity 0.3s ease-out, transform 0.3s ease-out;
    opacity: 0;
    pointer-events: none;
    z-index: 1;
}

.gmf-loot-crate-open-image.gmf-open {
    opacity: 1 !important;
    transform: translate(-50%, 50%);
}
</style>

<script>
import showLootCrateRewards from '@/widgets/LootCrate/showLootCrateRewards';

export default {
    name: 'OpenLootCrateModal',
    inject: [
        'lootCrate',
        'closeModal',
        'contents',
    ],
    data() {
        return {
            openAnim: false,
            lootCratePos: false,
        };
    },
    computed: {
        openLootCrateUrl() {
            if (! this.lootCrate) return '';

            if (this.openAnim && this.lootCrate.openImageUrl) {
                return this.lootCrate.openImageUrl || this.lootCrate.imageUrl || this.lootCrate.iconUrl;
            }

            return this.lootCrate.beforeOpenImageUrl || this.lootCrate.iconUrl || this.lootCrate.openImageUrl;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.lootCratePos = true; // Trigger animation
        });

        setTimeout(() => {
            this.openAnim = true;

            setTimeout(() => {
                showLootCrateRewards(this.lootCrate, {
                    autoOpen: false,
                    contents: this.contents,
                });
                this.closeModal();
            }, 2000); // @TODO: try to read delay from unlock animation length
        }, 300);
    },
};
</script>